import React from 'react';
import ProductCard from '../../components/ProductCard';
import Style from './Faqs.module.scss';


const Faqs = () => {
  return (
    <div className={Style.container}>
     Faq
    </div>
  )
}

export default Faqs;